import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'materialize-css'
import 'materialize-css/dist/css/materialize.min.css'
import './Resources/css/fonts.css'
import './Resources/css/index.css'
import './Styles/main.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'react-input-range/lib/css/index.css'

if (window.location.pathname === '/') {
    window.location.href = '/login'
}

ReactDOM.render(<App />, document.getElementById('root'))
serviceWorker.unregister()
